<template>
  <div class="content_box">
    <div class="head_box" @click="selectCons">
      <div class="head_left">
        <div class="user_name">{{activeConsInfo.consName}}</div>
        <div class="info">用电户号 {{activeConsInfo.consNo}}</div>
        <div class="info">{{activeConsInfo.elecAddr}}</div>
      </div>
      <div class="head_right">
        <img src="@/assets/zhankai3.png" class="zhankai_img" />
      </div>
    </div>
    <div class="body_box">
      <div class="change_box">
        <div @click="changeType('month')" :class="type=='month'?'active2':''">月度电量</div>
        <div @click="changeType('day')" :class="type=='day'?'active2':''">日度电量</div>
      </div>
      <div class="time_box" v-if="type=='month'">
        <div :class="setYear==year?'active':''" @click="changeYear(year)">{{year}}年</div>
        <div :class="setYear==year-1?'active':''" @click="changeYear(year-1)">{{year-1}}年</div>
        <div :class="setYear==year-2?'active':''" @click="changeYear(year-2)">{{year-2}}年</div>
      </div>
      <div class="time_box" v-else>
        <div :class="days==7?'active':''" @click="changeDays(7)">7天</div>
        <div :class="days==30?'active':''" @click="changeDays(30)">30天</div>
      </div>
      <div class="echats_box">
        <div v-if="type=='month'" class="echats_title">月用电分布图</div>
        <div v-else class="echats_title">日用电分布图</div>
        <div id="echats_main"></div>
        <div class="table_box" v-if="type=='month'">
          <div class="table_head">
            <div class="table_column" style="width:33%;text-align:left">月份</div>
            <!-- <div class="table_column" style="width:50px">电表号</div> -->
            <div class="table_column" style="width:33%;text-align:center">电量（千瓦时）</div>
            <div class="table_column" style="width:33%;text-align:right">倍率</div>
            <!-- <div class="table_column" style="width:50px">电费（元）</div> -->
          </div>
          <div
            class="table_body"
            v-for="item in montchPowerData.monthPowerDataList"
            @click="showHistory(item.month)"
          >
            <div class="table_data" style="width:33%;text-align:left">{{item.month}}</div>
            <!-- <div class="table_data" style="width:50px">{{item.meternbbh}}</div> -->
            <div class="table_data" style="width:33%;text-align:center">{{item.energy}}</div>
            <div class="table_data" style="width:33%;text-align:right">{{item.beil}}</div>
            <!-- <div class="table_data" style="width:60px">{{item.charge}}</div> -->
          </div>
          <div class="count_box">
            <div style="display:flex">
              <img src="@/assets/dianliang.png" />
              <div>电量统计：</div>
              <div>{{powerCount.toFixed(2)}}千瓦时</div>
            </div>
            <!-- <div style="display:flex">
              <img src="@/assets/jinqia.png" />
              <div>电费统计：</div>
              <div>{{priceCount}}元</div>
            </div>-->
          </div>
        </div>
        <div class="table_box" v-else>
          <div class="table_head">
            <div class="table_column" style="width:100px">时间</div>
            <div class="table_column" style="width:100px">电量（千瓦时）</div>
          </div>
          <div class="table_body2" v-for="(item,index) in dayPowerData.dayPowerDataList">
            <div class="body_head" @click="show(item,index)">
              <div class="body_time" style="width:150px;text-align:center">{{item.day}}</div>
              <div class="body_power" style="width:100px;text-align:center">{{item.energy}}</div>
              <img src="@/assets/arrow-bottom.png" v-if="item.show" />
              <img src="@/assets/arrow-right.png" v-else />
            </div>
            <div class="body_info" v-show="item.show">
              <div class="info_left">
                <div class="info_item">
                  <div class="circle" style="background:#f3b987"></div>
                  <div>尖用电：{{item.jian}}</div>
                </div>
                <div class="info_item">
                  <div class="circle" style="background:#f5e293"></div>
                  <div>峰用电：{{item.feng}}</div>
                </div>
                <div class="info_item">
                  <div class="circle" style="background:#82bbf0"></div>
                  <div>平用电：{{item.ping}}</div>
                </div>
                <div class="info_item">
                  <div class="circle" style="background:#95d986"></div>
                  <div>谷用电：{{item.gu}}</div>
                </div>
              </div>
              <div class="info_right">
                <div :id="'pie'+index" class="info_pie"></div>
              </div>
            </div>
          </div>
          <div class="count_box">
            <div style="display:flex">
              <img src="@/assets/dianliang.png" />
              <div>电量统计：</div>
              <div>{{powerCount.toFixed(2)}}千瓦时</div>
            </div>
            <!-- <div style="display:flex">
              <img src="@/assets/jinqia.png" />
              <div>电费统计：</div>
              <div>{{priceCount}}元</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import {
  queryMonthPowerChartData,
  queryDayPowerChartData,
  queryBindFeeCons
} from "@/api/user.js";
import { Notify } from "vant";
export default {
  data() {
    return {
      year: "",
      days: "7",
      consId: "",
      setYear: "",
      type: "month",
      powerCount: 0,
      priceCount: 0,
      dayPowerData: {},
      activeConsInfo: {},
      montchPowerData: {}
    };
  },
  created() {
    this.consId = this.$route.query.consId ? this.$route.query.consId : "";
    var date = new Date();
    this.year = date.getFullYear();
    this.setYear = date.getFullYear();
    //查询当前已绑定的户号
    queryBindFeeCons(this.consId).then(res => {
      if (res.data.status == 200) {
        this.activeConsInfo = res.data.object;
      } else {
        Notify({ type: "danger", message: res.data.msg });
      }
    });
  },
  mounted() {
    this.changeType("month");
  },
  methods: {
    showHistory(month) {
      this.$router.push({
        path: `/tcmr/history?consId=${this.consId}&month=${
          this.setYear
        }-${month.replace("月", "")}`
      });
    },
    changeYear(year) {
      this.setYear = year;
      this.changeType("month");
    },
    changeDays(day) {
      this.days = day;
      this.changeType("day");
    },
    selectCons() {
      this.$router.push({
        path: `/tcmr/changeUserCount?consId=${this.consId}`
      });
    },
    show(item, i) {
      this.dayPowerData.dayPowerDataList.forEach((ele, index) => {
        if (i == index) {
          this.dayPowerData.dayPowerDataList[index].show = !this.dayPowerData
            .dayPowerDataList[index].show;
          this.dayPowerData.dayPowerDataList[index].options = {
            tooltip: {
              trigger: "item"
            },
            series: [
              {
                type: "pie",
                radius: "50%",
                label: {
                  //饼图图形上的文本标签
                  normal: {
                    show: true,
                    position: "inner", //标签的位置
                    textStyle: {
                      fontWeight: 500,
                      fontSize: 9, //文字的字体大小
                      color: "#ffffff"
                    },
                    formatter: "{d}%"
                  }
                },
                data: [
                  { value: ele.jian, name: "尖用电" },
                  { value: ele.feng, name: "峰用电" },
                  { value: ele.ping, name: "平用电" },
                  { value: ele.gu, name: "谷用电" }
                ]
              }
            ],
            color: ["#f3b987", "#f5e293", "#82bbf0", "#95d986"]
          };
          var chartDom = document.getElementById("pie" + index);
          var myChart1 = echarts.init(chartDom);
          myChart1.setOption({}, true);
          ele.options && myChart1.setOption(ele.options);
        }
      });
      this.dayPowerData.dayPowerDataList.sort();
    },
    changeType(type) {
      this.type = type;
      this.powerCount = 0;
      if (type == "month") {
        if (document.getElementById("echats_main")) {
          queryMonthPowerChartData({
            consId: this.consId,
            year: this.setYear
          }).then(res => {
            if (res.data.status == 200) {
              this.montchPowerData = res.data.object;
              this.montchPowerData.monthPowerDataList.forEach(ele => {
                this.powerCount += parseFloat(ele.energy);
              });
              this.montchPowerData.chartsOption.series.forEach(element => {
                element.stack = "power";
                // element.emphasis.focus = "series";
              });
              var option1;
              option1 = {
                color: ["#95d986", "#82bbf0", "#f5e293", "#f3b987"],
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow"
                  }
                },
                legend: {},
                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                xAxis: {
                  type: "category",
                  data: this.montchPowerData.chartsOption.xAxisData
                },
                yAxis: [
                  {
                    name: "单位：千瓦时",
                    type: "value"
                  }
                ],
                series: this.montchPowerData.chartsOption.series.reverse()
              };
              var chartDom1 = document.getElementById("echats_main");
              var myChart1 = echarts.init(chartDom1);
              myChart1.setOption({}, true);
              option1 && myChart1.setOption(option1);
            } else {
              Notify({ type: "danger", message: res.data.msg });
            }
          });
        }
      } else {
        if (document.getElementById("echats_main")) {
          var chartDom2 = document.getElementById("echats_main");
          var myChart2 = echarts.init(chartDom2);
          var option2;
          queryDayPowerChartData({
            consId: this.consId,
            days: this.days
          }).then(res => {
            if (res.data.status == 200) {
              this.dayPowerData = res.data.object;
              this.dayPowerData.dayPowerDataList.forEach(ele => {
                console.log(11111111111);
                this.powerCount += parseFloat(ele.energy);
              });
              res.data.object.dayPowerDataList.forEach(ele => {
                ele.show = false;
              });
              option2 = {
                xAxis: {
                  type: "category",
                  data: this.dayPowerData.chartsOption.xAxisData
                },
                yAxis: {
                  type: "value",
                  name: "单位：千瓦时"
                },
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "cross",
                    label: {
                      backgroundColor: "#6a7985"
                    }
                  }
                },

                series: this.dayPowerData.chartsOption.series
              };
              myChart2.setOption({}, true);
              option2 && myChart2.setOption(option2);
            } else {
              Notify({ type: "danger", message: res.data.msg });
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.info_pie {
  width: 180px;
  height: 180px;
}
.left_img {
  right: 0px;
  position: absolute;
}
#echats_main2 {
  height: 50px;
}
.info_item {
  display: flex;
  font-size: 0.2rem;
  margin-top: 0.1rem;
  align-items: center;
}
.circle {
  width: 7px;
  height: 7px;
  margin-right: 2px;
  border-radius: 50%;
}
.body_head {
  display: flex;
  text-align: left;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  position: relative;
  align-items: center;
  padding: 0.1rem 0.1rem;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
}
.table_body2 {
  margin: 0 0.2rem;
}
.body_info {
  display: flex;
  font-size: 0.2rem;
  align-items: center;
  justify-content: center;
}
.table_data {
  text-align: center;
}
.active2 {
  margin: 2px;
  background: #fff;
  border-radius: 18px;
  color: #329dff;
  padding: 0.05rem 0.2rem;
}
.change_box {
  font-size: 0.24rem;
  color: #9cbfec;
  background: #329dff;
  width: 3rem;
  display: flex;
  margin: 0 auto;
  font-size: 0.24rem;
  height: 0.6rem;
  align-items: center;
  border-radius: 18px;
  justify-content: space-around;
}
.count_box {
  display: flex;
  padding: 0.2rem;
  font-size: 0.22rem;
  justify-content: space-between;
}
.count_box img {
  width: 19px;
  height: 19px;
}
.table_head {
  display: flex;
  margin: 0 0.2rem;
  color: #919392;
  font-size: 0.22rem;
  background: #f0f0f0;
  padding: 0.1rem 0.1rem;
  justify-content: space-around;
}
.table_body {
  display: flex;
  text-align: left;
  margin: 0 0.2rem;
  font-size: 0.24rem;
  align-items: center;
  padding: 0.1rem 0.1rem;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
}
#echats_main {
  height: 300px;
  padding-left: 10px;
}
#echats_main2 {
  height: 300px;
}

.echats_box {
  margin-top: 0.2rem;
}
.echats_title {
  font-size: 0.26rem;
}
.active {
  color: #319dff;
  border-bottom: 2px solid #319dff;
}
.body_box {
  background: #fff;
  padding-top: 0.3rem;
}
.time_box {
  display: flex;
  font-size: 0.28rem;
  align-items: center;
  margin-top: 0.5rem;
  padding-bottom: 0.1rem;
  justify-content: space-around;
}
.zhankai_img {
  display: block;
}
.content_box {
  padding: 0.2rem;
  background: #f4f4f4;
}
.head_box {
  display: flex;
  margin: 0.1rem;
  padding: 0.2rem;
  text-align: left;
  align-items: center;
  border-radius: 0.1rem;
  background: #ffffff;
  justify-content: space-between;
}
.user_name {
  font-weight: bold;
  font-size: 0.28rem;
}
.info {
  font-size: 0.24rem;
  margin-top: 0.05rem;
}
</style>